module.exports = __webpack_public_path__ + "img/07447199000140.c47dc441.png";